import React from "react";
import SearchOutfitList from "container/searchForUser/SearchOutfitList";
import MembershipRecommendationButtonView from "presentational/common/MembershipRecommendationButtonView";
import { withStore } from "store/storeHandler";
import { getDeviceType } from "lib/deviceInfo";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const css = {
  membershipRecommendBtnWrapper: {
    marginTop:
      getDeviceType() === "mobile"
        ? -mobileCss.paddingOfScrollEnd
        : -desktopCss.paddingOfScrollEnd,
    marginBottom:
      getDeviceType() === "mobile"
        ? mobileCss.paddingOfScrollEnd
        : desktopCss.paddingOfScrollEnd,
    display: "flex",
    justifyContent: "center"
  }
};

SearchOutfitListPanel.propTypes = {
  getList: PropTypes.func.isRequired
};

function SearchOutfitListPanel(props) {
  const { getList, outfitList, isLoading, isEnd, needCreative } = props;

  const getMembershipRecommendBtn = () => {
    if (isLoading || !needCreative) return null;
    return (
      <div style={css.membershipRecommendBtnWrapper}>
        <MembershipRecommendationButtonView buttonLocation="searchPage" />
      </div>
    );
  };

  const getListElement = () => {
    return (
      <SearchOutfitList
        getList={getList}
        outfitList={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
      />
    );
  };

  return (
    <div>
      {getListElement()}
      {getMembershipRecommendBtn()}
    </div>
  );
}

export default withStore({
  stateMap: {
    search: ["outfitList", "isEnd", "isLoading", "needCreative"]
  }
})(SearchOutfitListPanel);
